import { NotificationType } from '@types';
import { convertDateAndTimeToDisplayFormat } from '@utils';

import styles from './notificationListItem.module.scss';

export interface NotificationListItemProps {
	notification: NotificationType;
	onItemClick: (notification: NotificationType) => void;
	selected: boolean;
}

export const NotificationListItem = ({
	notification,
	onItemClick,
	selected,
}: NotificationListItemProps) => {
	const { title, content, published, read } = notification;
	return (
		<div
			className={[
				styles.container,
				selected && styles['container-selected'],
				!read && styles['container-unread'],
			].join(' ')}
			onClick={() => {
				onItemClick(notification);
			}}
			data-testid="notificationItem"
		>
			{!read && <div className={styles['container-unread-border']} />}
			<div className={styles['container-left']}>
				<p className={styles['container-left-title']} data-testid="notificationItemTitle">
					{title}
				</p>
				<div className={styles['container-left-content']}>
					<p>{content}</p>
				</div>
			</div>
			<div className={styles['container-right']}>
				<p>{convertDateAndTimeToDisplayFormat(published, 'date')}</p>
				<p>{convertDateAndTimeToDisplayFormat(published, 'time')}</p>
			</div>
		</div>
	);
};
